import { render, staticRenderFns } from "./ProfileDetailsView.vue?vue&type=template&id=5d690a6e"
import script from "./ProfileDetailsView.vue?vue&type=script&lang=js"
export * from "./ProfileDetailsView.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetailsView.vue?vue&type=style&index=0&id=5d690a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports